export const ActionTypes = {
  FETCH_ALL: 'services/products/fetch_all',
  FETCH_ALL_PRODUCTS_DATA: 'services/products/fetch_all_products_data',
  FETCH_PRODUCT_BY_ID_DATA: 'services/products/fetch_product_by_id_data',
  SET_PRODUCT_BY_ID_DATA: 'services/products/set_product_by_id_data',
  FETCH_ALL_SUCCESS: 'services/products/fetch_all_success',
  SET_LOADER_STATUS: 'services/products/set_loader_status',
  EXPORT_PRODUCT_DATA: 'services/products/export_product_data',
  EXPORT_PRODUCT_DATA_LOADER: 'services/products/export_product_data_loader',
  SET_EXPORT_PRODUCT_DATA: 'services/products/set_product_export_data',
  SET_ALL: 'services/products/set_all',
  SET_ALL_PRODUCTS_DATA: 'services/products/set_all_products_data',
  ADD_OR_UPDATE_PRODUCT: 'services/products/add_or_update_product',
  DELETE_PRODUCT: 'services/products/delete_product',
  GET_PRODUCTS_BY_FACTORY_ID: 'services/products/get_products_by_factory_id',
  SET_PRODUCTS_BY_FACTORY_ID: 'services/products/set_products_by_factory_id',
  GET_PRODUCTS_BY_TOOL_ID: 'services/products/get_products_by_tool_id',
  SET_PRODUCTS_BY_TOOL_ID: 'services/products/set_products_by_tool_id',
  FETCH_TOOLS_BY_MEASUREMENT_UNIT: 'services/products/get_tools_by_measurement_unit',
  SET_TOOLS_BY_MEASUREMENT_UNIT: 'services/products/set_tools_by_measurement_unit',

  IS_PRODUCT_ASSIGNED: 'services/products/is_product_assigned',
  SET_PRODUCT_ASSIGNED: 'services/products/set_product_assigned',
  SET_PRODUCT_ASSIGNED_LOADER_STATUS: 'services/products/set_product_assigned_loader_status',
  SET_IMPORT_EXCEL_PRODUCT_FILE: 'services/product/set_import_excel_product_file',
  SET_IMPORT_EXCEL_PRODUCT_FILE_LOADER_STATUS: 'services/product/set_import_excel_product_file_loader_status',

  FETCH_PRODUCT_ATTRIBUTE_VALUES: 'services/products/fetch_product_attribute_values',
  FETCH_PRODUCTS_ATTRIBUTES: 'services/products/fetch_products_attributes',
  SET_PRODUCTS_ATTRIBUTES: 'services/products/set_products_attributes',
  FETCH_PRODUCT_ATTRIBUTE_VALUES_BY_ID: 'services/products/fetch_product_attribute_values_by_id',
  SET_PRODUCT_ATTRIBUTE_VALUES: 'services/products/set_product_attribute_values',
  SET_PRODUCT_ATTRIBUTE_VALUES_BY_ID: 'services/products/set_product_attribute_values_by_id',
  ADD_OR_UPDATE_PRODUCT_ATTRIBUTE_VALUES: 'services/products/add_or_update_product_attribute_values',
  DELETE_PRODUCT_ATTRIBUTE_VALUES: 'services/products/delete_product_attribute_values',
  FETCH_PRODUCT_ATTRIBUTE_DATA_TYPES: 'services/products/fetch_product_attribute_data_types',
  SET_PRODUCT_ATTRIBUTE_DATA_TYPES: 'services/products/set_product_attribute_data_types',
  FETCH_ALL_GLOBAL_ATTRIBUTES: 'services/products/fetch_all_global_attributes',
  FETCH_GLOBAL_ATTRIBUTES_BY_ID: 'services/products/fetch_global_attributes_by_id',
  FETCH_GLOBAL_ATTRIBUTES_BY_PRODUCT_ID: 'services/products/fetch_global_attributes_by_product_id',
  SET_GLOBAL_ATTRIBUTES_BY_PRODUCT_ID: 'services/products/set_global_attributes_by_product_id',
  SET_GLOBAL_ATTRIBUTES_BY_ID: 'services/products/set_global_attributes_by_id',
  SET_ALL_GLOBAL_ATTRIBUTES: 'services/products/set_all_global_attributes',
  GET_ALL_CSV_DATA: 'services/products/get_all_csv_data',
  SET_EXPORT_ATTRIBUTE_DATA: 'services/products/set_export_attribute_data',
  PRODUCT_ATTRIBUTE_VALUES_IMPORT: 'services/products/product_attribute_values_import',
  SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_VALUES_FILE: 'services/products/set_import_excel_product_attribute_values_file',
  SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_VALUES_LOADER:
    'services/products/set_import_excel_product_attribute_values_loader',

  PRODUCT_IMPORT: 'services/products/product_import',

  PRODUCT_EXPORT: 'services/products/product_export',
  SET_PRODUCT_EXPORT: 'services/products/set_product_export',
  SET_PRODUCT_EXPORT_LOADER_STATUS: 'services/products/set_product_export_loader_status',
  GET_PRODUCT_IMAGE_VALIDATE: 'services/products/get_product_image_validate',
  SET_PRODUCT_IMAGE_VALIDATE: 'services/products/set_product_image_validate',
};

const fetchAll = ({ productParams }) => ({
  productParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchProductAttributeValues = ({ productAttributeValuesParams }) => ({
  productAttributeValuesParams,
  type: ActionTypes.FETCH_PRODUCT_ATTRIBUTE_VALUES,
});

const fetchProductsAttributes = ({ productAttributeValuesParams }) => ({
  productAttributeValuesParams,
  type: ActionTypes.FETCH_PRODUCTS_ATTRIBUTES,
});

const setProductsAttributes = ({ productsAttributes }) => ({
  productsAttributes,
  type: ActionTypes.SET_PRODUCTS_ATTRIBUTES,
});

const importExcelProductAttributeValuesFile = ({ importFileParams, productAttributeValuesParams }) => ({
  importFileParams,
  productAttributeValuesParams,
  type: ActionTypes.PRODUCT_ATTRIBUTE_VALUES_IMPORT,
});
const setImportExcelProductAttributeValuesFile = ({ importProductAttributeValuesFile }) => ({
  importProductAttributeValuesFile,
  type: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_VALUES_FILE,
});
const setImportExcelProductAttributeValuesLoader = ({ importExcelAttributeFileLoader }) => ({
  importExcelAttributeFileLoader,
  type: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_VALUES_LOADER,
});

const fetchProductAttributeValuesById = ({ id }) => ({
  id,
  type: ActionTypes.FETCH_PRODUCT_ATTRIBUTE_VALUES_BY_ID,
});

const fetchAllGlobalAttributes = () => ({
  type: ActionTypes.FETCH_ALL_GLOBAL_ATTRIBUTES,
});

const fetchGlobalAttributesById = ({ id }) => ({
  id,
  type: ActionTypes.FETCH_GLOBAL_ATTRIBUTES_BY_ID,
});

const setGlobalAttributesById = ({ globalAttributesById }) => ({
  globalAttributesById,
  type: ActionTypes.SET_GLOBAL_ATTRIBUTES_BY_ID,
});

const fetchGlobalAttributesByProductId = ({ id, productAttributeValuesParams }) => ({
  id,
  productAttributeValuesParams,
  type: ActionTypes.FETCH_GLOBAL_ATTRIBUTES_BY_PRODUCT_ID,
});

const setGlobalAttributesByProductId = ({ globalAttributesByProduct }) => ({
  globalAttributesByProduct,
  type: ActionTypes.SET_GLOBAL_ATTRIBUTES_BY_PRODUCT_ID,
});

const setAllGlobalAttributes = ({ allGlobalAttributes }) => ({
  allGlobalAttributes,
  type: ActionTypes.SET_ALL_GLOBAL_ATTRIBUTES,
});

const GetAllAttributeCSVData = ({ searchText }) => ({
  searchText,
  type: ActionTypes.GET_ALL_CSV_DATA,
});

const setAttributesDataExport = ({ productAttributeExportCSVFile }) => ({
  productAttributeExportCSVFile,
  type: ActionTypes.SET_EXPORT_ATTRIBUTE_DATA,
});

const fetchProductAttributeDataTypes = () => ({
  type: ActionTypes.FETCH_PRODUCT_ATTRIBUTE_DATA_TYPES,
});

const setProductAttributeDataTypes = ({ dataTypes }) => ({
  dataTypes,
  type: ActionTypes.SET_PRODUCT_ATTRIBUTE_DATA_TYPES,
});

const setProductAttributeValues = ({ productAttributeValues }) => ({
  productAttributeValues,
  type: ActionTypes.SET_PRODUCT_ATTRIBUTE_VALUES,
});

const setProductAttributeValuesById = ({ productAttributeValuesById }) => ({
  productAttributeValuesById,
  type: ActionTypes.SET_PRODUCT_ATTRIBUTE_VALUES_BY_ID,
});

const addorUpdateProductAttributeValues = ({
  productAttributeValuesData,
  actionName,
  productAttributeValuesParams,
  onSuccess,
}) => ({
  productAttributeValuesData,
  actionName,
  productAttributeValuesParams,
  onSuccess,
  type: ActionTypes.ADD_OR_UPDATE_PRODUCT_ATTRIBUTE_VALUES,
});

const deleteProductAttributeValues = ({ id, productAttributeValuesParams }) => ({
  id,
  productAttributeValuesParams,
  type: ActionTypes.DELETE_PRODUCT_ATTRIBUTE_VALUES,
});

const fetchProductById = ({ productId }) => ({
  productId,
  type: ActionTypes.FETCH_PRODUCT_BY_ID_DATA,
});

const setProductById = ({ productDataById }) => ({
  productDataById,
  type: ActionTypes.SET_PRODUCT_BY_ID_DATA,
});

const fetchAllProductsData = () => ({
  type: ActionTypes.FETCH_ALL_PRODUCTS_DATA,
});

const setAllProductsData = ({ allProductsData }) => ({
  allProductsData,
  type: ActionTypes.SET_ALL_PRODUCTS_DATA,
});

const setToolsByMeasurementUnit = ({ tools }) => ({
  tools,
  type: ActionTypes.SET_TOOLS_BY_MEASUREMENT_UNIT,
});

const setAll = ({ allProduct }) => ({
  allProduct,
  type: ActionTypes.SET_ALL,
});

const addorUpdateProduct = ({ productData, actionName, productParams, callback }) => ({
  productData,
  actionName,
  productParams,
  callback,
  type: ActionTypes.ADD_OR_UPDATE_PRODUCT,
});

const deleteProduct = ({ id, productParams }) => ({
  id,
  productParams,
  type: ActionTypes.DELETE_PRODUCT,
});

const getProductsByFactoryId = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.GET_PRODUCTS_BY_FACTORY_ID,
});

const setProductsByFactoryId = ({ factoryProducts }) => ({
  factoryProducts,
  type: ActionTypes.SET_PRODUCTS_BY_FACTORY_ID,
});
const getProductsByToolId = ({ toolId }) => ({
  toolId,
  type: ActionTypes.GET_PRODUCTS_BY_TOOL_ID,
});

const setProductsByToolId = ({ toolProducts }) => ({
  toolProducts,
  type: ActionTypes.SET_PRODUCTS_BY_TOOL_ID,
});

const getProductImageValidate = ({ productData }) => ({
  productData,
  type: ActionTypes.GET_PRODUCT_IMAGE_VALIDATE,
});

const setProductImageValidate = ({ imageurl }) => ({
  imageurl,
  type: ActionTypes.SET_PRODUCT_IMAGE_VALIDATE,
});

const getToolsByMeasurementUnit = ({ measurementUnitId }) => ({
  measurementUnitId,
  type: ActionTypes.FETCH_TOOLS_BY_MEASUREMENT_UNIT,
});

const isProductAssigned = ({ productId }) => ({
  productId,
  type: ActionTypes.IS_PRODUCT_ASSIGNED,
});

const setProductAssigned = ({ productAssigned }) => ({
  productAssigned,
  type: ActionTypes.SET_PRODUCT_ASSIGNED,
});

const setProductAssignedLoader = ({ productAssignedLoader }) => ({
  productAssignedLoader,
  type: ActionTypes.SET_PRODUCT_ASSIGNED_LOADER_STATUS,
});

const importExcelProductFile = ({ importFileParams, productParams }) => ({
  importFileParams,
  productParams,
  type: ActionTypes.PRODUCT_IMPORT,
});

const productExport = ({ productExportParams }) => ({
  productExportParams,
  type: ActionTypes.PRODUCT_EXPORT,
});

// export complete product data in csv call
const productDataExport = ({ productExportParams }) => ({
  productExportParams,
  type: ActionTypes.EXPORT_PRODUCT_DATA,
});

// export product data loader
const productDataExportLoader = ({ productExportCSVLoader }) => ({
  productExportCSVLoader,
  type: ActionTypes.EXPORT_PRODUCT_DATA_LOADER,
});

// set export product data
const setProductDataExport = ({ productExportCSVData }) => ({
  productExportCSVData,
  type: ActionTypes.SET_EXPORT_PRODUCT_DATA,
});

const setProductExportData = ({ productExportData }) => ({
  productExportData,
  type: ActionTypes.SET_PRODUCT_EXPORT,
});

const setProductExportLoader = ({ productExportLoader }) => ({
  productExportLoader,
  type: ActionTypes.SET_PRODUCT_EXPORT_LOADER_STATUS,
});

const setImportExcelProductFile = ({ importProductFile }) => ({
  importProductFile,
  type: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_FILE,
});
const setImportExcelProductFileLoader = ({ importExcelFileLoader }) => ({
  importExcelFileLoader,
  type: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_FILE_LOADER_STATUS,
});

const GetAllCSVData = ({ productExportParams }) => ({
  productExportParams,
  type: ActionTypes.EXPORT_PRODUCT_DATA,
});

export default {
  fetchAll,
  fetchAllProductsData,
  fetchProductsAttributes,
  setProductsAttributes,
  setAll,
  fetchProductById,
  setProductById,
  GetAllCSVData,
  productDataExport,
  fetchProductAttributeValues,
  fetchProductAttributeValuesById,
  setProductAttributeValuesById,
  setProductAttributeValues,
  addorUpdateProductAttributeValues,
  deleteProductAttributeValues,
  fetchProductAttributeDataTypes,
  setProductAttributeDataTypes,
  fetchGlobalAttributesById,
  fetchGlobalAttributesByProductId,
  importExcelProductAttributeValuesFile,
  setImportExcelProductAttributeValuesFile,
  setImportExcelProductAttributeValuesLoader,
  fetchAllGlobalAttributes,
  setGlobalAttributesByProductId,
  setGlobalAttributesById,
  setAllGlobalAttributes,
  GetAllAttributeCSVData,
  setAttributesDataExport,
  setAllProductsData,
  setLoader,
  productDataExportLoader,
  setProductDataExport,
  addorUpdateProduct,
  deleteProduct,
  getProductsByFactoryId,
  setProductsByFactoryId,
  getProductsByToolId,
  setProductsByToolId,
  getToolsByMeasurementUnit,
  setToolsByMeasurementUnit,
  isProductAssigned,
  setProductAssigned,
  setProductAssignedLoader,
  importExcelProductFile,
  productExport,
  setProductExportData,
  setProductExportLoader,
  setImportExcelProductFile,
  setImportExcelProductFileLoader,
  getProductImageValidate,
  setProductImageValidate,
};
